// extracted by mini-css-extract-plugin
export var category = "_jd-9";
export var categoryHeader = "_jd-e";
export var container = "_jd-0";
export var group = "_jd-a";
export var groupItems = "_jd-f";
export var groupSeparator = "_jd-j";
export var loading = "_jd-1";
export var noResults = "_jd-3";
export var placeholder = "_jd-2";
export var resultContent = "_jd-5";
export var resultIcon = "_jd-c";
export var resultItem = "_jd-g";
export var resultMeta = "_jd-8";
export var resultSubtitle = "_jd-7";
export var resultSuffix = "_jd-i";
export var resultTitle = "_jd-6";
export var resultsList = "_jd-4";
export var searchGroup = "_jd-d";
export var selected = "_jd-h";
export var subgroup = "_jd-b";